import React from "react";

import Box from "../Box";

import styled from "styled-components";
import { LayoutProps } from "styled-system";
import { CText } from "@carrefour/design-system-components-react";
import BaseDashboardCard from "../BaseDashboardCard";
import useBreakPoint from "../../utils/useBreakPoint";
import { ComplianceRates } from "../../types/drive";
import { useTranslation } from "react-i18next";
import { formatPercentage } from "../../utils/numberUtils";

const Text = styled(CText)<{ color?: string }>`
  color: ${(props) => props.color};
  font-family: system-ui;
`;
type ComplianceRateCardProps = {
  driveComplianceData?: ComplianceRates | null;
  ladComplianceData?: ComplianceRates | null;
  isUnavailable: boolean;
  messageError?: string;
  isLoading: boolean;
  openInformationModal: (title?: string) => void;
} & Pick<LayoutProps, "width">;

const BoxCustom = styled(Box)<{ gap?: string; isBorded?: boolean }>`
  gap: ${(props) => props.gap};
  display: flex;
  border-bottom: ${(props) => (props?.isBorded ? " 1px solid #D9D9D9" : "")};
`;

const ComplianceRateCard = ({
  driveComplianceData,
  ladComplianceData,
  ...res
}: ComplianceRateCardProps) => {
  const isBreak = useBreakPoint();

  const {t} = useTranslation();

  return (
    <BaseDashboardCard
      hasModal={true}
      title={t('ecommerce.taux_conformite_j_1')}
      size={"big"}
      importedDateTime={driveComplianceData?.importedDateTime || ladComplianceData?.importedDateTime}
      {...res}
    >
      <BoxCustom
        justifyContent={"flex-start"}
        alignItems={"flex-start"}
        flexDirection={"column"}
        gap="1rem"
      >
        {driveComplianceData &&
          itemOrder(
             t('ecommerce.drive'),
            driveComplianceData?.beforeSubstitutionComplianceRate,
            driveComplianceData?.afterSubstitutionComplianceRate,
            isBreak,
            t('ecommerce.avant_substitution'),
            t('ecommerce.apres_substitution'),
          )}
        {ladComplianceData && driveComplianceData && (
          <BoxCustom isBorded={true} width={"100%"}></BoxCustom>
        )}
        {ladComplianceData &&
          itemOrder(
             t('ecommerce.lad'),
            ladComplianceData?.beforeSubstitutionComplianceRate,
            ladComplianceData?.afterSubstitutionComplianceRate,
            isBreak,
            t('ecommerce.avant_substitution'),
            t('ecommerce.apres_substitution'),
          )}
      </BoxCustom>
    </BaseDashboardCard>
  );
};

const itemOrder = (
  name: string,
  beforeSubstitution: number | null | undefined,
  afterSubstitution: number | null | undefined,
  isBreak: string,
  beforeSubLab: string,
  afterSubLab: string,
) => {
  const isValidBeforeSubstitution =
    typeof beforeSubstitution === "number" && Number.isFinite(beforeSubstitution);
  const isValidAfterSubstitution =
    typeof afterSubstitution === "number" && Number.isFinite(afterSubstitution);

  return (
    <BoxCustom
      display={"flex"}
      flexDirection={"column"}
      width={"100%"}
      gap="6px"
    >
      <Box textAlign={"left"}>
        <Text size={"l"} tagStyle="h3" bold>
          {name}
        </Text>
      </Box>
      <BoxCustom
        display={"flex"}
        width={"100%"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <BoxCustom
          display={"flex"}
          flexDirection={"column"}
          gap={"8px"}
          textAlign={"left"}
          borderRadius={1}
          border={"1px solid #E5E5E5"}
          py={1}
          px={2}
          width={"47%"}
        >
          <Box display={"flex"} alignItems={"center"} textAlign={"left"}>
            <Text size={"s"}>{beforeSubLab}</Text>
          </Box>

          <BoxCustom display={"flex"} alignItems={"end"}>
            <Text color={"#CC4010"} size="l" tagStyle="h2">
              {isValidBeforeSubstitution
                ? `${formatPercentage(beforeSubstitution * 100, '')}`
                : "-"}
            </Text>
            {isValidBeforeSubstitution && (
              <Text tagStyle="p" color={"#CC4010"}>
                {"%"}
              </Text>
            )}
          </BoxCustom>
        </BoxCustom>
        <BoxCustom
          display={"flex"}
          flexDirection={"column"}
          gap={"8px"}
          textAlign={"left"}
          borderRadius={1}
          border={"1px solid #E5E5E5"}
          py={1}
          px={2}
          width={"47%"}
        >
          <Box display={"flex"} alignItems={"center"} textAlign={"left"}>
            <Text size={"s"}>{afterSubLab}</Text>
          </Box>
          <BoxCustom display={"flex"} alignItems={"end"}>
            <Text color={"#33691E"} size="l" tagStyle="h2">
              {isValidAfterSubstitution
                ? `${formatPercentage(afterSubstitution * 100, '')}`
                : "-"}
            </Text>
            {isValidAfterSubstitution && (
              <Text tagStyle="p" color={"#33691E"}>
                {"%"}
              </Text>
            )}
          </BoxCustom>
        </BoxCustom>
      </BoxCustom>
    </BoxCustom>
  );
};
export default ComplianceRateCard;
